// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const OperatorId = 1;
// const lteHttpBaseUrl ="http://localhost:8088";//"https://lteapi.cyberspace.net.ng";//    // https://ltehttp.cyberspace.net.ng:442/';

const lteHttpBaseUrl ="https://ltehttp.cyberspace.net.ng:442";//"https://lteapi.cyberspace.net.ng";//    // https://ltehttp.cyberspace.net.ng:442/';

//const webHookUrl="http://212.100.86.49:8080/Billing/webhook";

const webHookUrl="https://ltemobilemid.cyberspace.net.ng/api/PaymentFactory/LTESelfCareWebhook";

export const environment = {
  
  production: true,
  lteHttpBaseUrl : (lteHttpBaseUrl),
  OperatorID: OperatorId,
    PortalCode:"PortalCode" + OperatorId,
  // PortalCode:"cyberlte",
  // IntegrationKey :"c041e4ba3ade40898e1eb9e8a16c4d16",//"005e84081f9f408586de873338fa54b7"
  // voiceIntegrationKey :"c041e4ba3ade40898e1eb9e8a16c4d16",
  // enterpriseIntegrationKey:"0edbb40477fb4b1b95e45bb2af44d6bd",
  // cyberPayApiUrl: "https://payment-api.staging.cyberpay.ng/api/v1/payments/",
  IntegrationKey : window['integrationKey'] || "3e1d7d40b9e043b694c7516148f23c3f",//"e38f9fbc3b8d4b4d866f1735b6d670e2", 
  voiceIntegrationKey : window['voiceIntegrationKey'] || "86d2f18326ea4783bbf5bee893fd0fcf",
  enterpriseIntegrationKey:window['enterpriseIntegrationKey'] ||"1552fba96cc94cab93523d18bdb8c496", 
  cyberPayApiUrl: "https://payment-api.cyberpay.ng/api/v1/payments",
  ProviderId : 4,
  GenericErrorMsg : 'An error occured',
  CyberPayReturnURL: `${location.protocol}//${location.host}/completecyberpay`,
  expiredAccId : 3,
  pausedAccId:0,
  UnsubscribeUrl:"http://externalconn.cyberspacelte.net.ng:9088/api/utilities/Unsubscribe",
 webhookUrl:webHookUrl,
 vat: 7.5

};
// // import 'zone.js/dist/zone-error';  // Included with Angular CLI.








// const OperatorId = 1;
// const lteHttpBaseUrl = window['url'];// || 'http://localhost:8088';
// //const webHookUrl= "http://212.100.86.49:8080/Billing/webhook";
// const webHookUrl= "https://ltemobilemid.cyberspace.net.ng/api/PaymentFactory/LTESelfCareWebhook";
// export const environment = {
//   production: true,
//   lteHttpBaseUrl:window['url'],
//   OperatorID: OperatorId,
//   PortalCode:"PortalCode" + OperatorId,
//  // IntegrationKey : window['integrationKey'] || "c041e4ba3ade40898e1eb9e8a16c4d16",
//   // IntegrationKey : window['integrationKey'] || "e38f9fbc3b8d4b4d866f1735b6d670e2", 
//   // voiceIntegrationKey : window['voiceIntegrationKey'] || "86d2f18326ea4783bbf5bee893fd0fcf",
//   // enterpriseIntegrationKey:window['enterpriseIntegrationKey']||"1552fba96cc94cab93523d18bdb8c496",
//   // cyberPayApiUrl:"https://payment-api.cyberpay.ng/api/v1/payments",
//   // ProviderId : 4,
// //   IntegrationKey :"c041e4ba3ade40898e1eb9e8a16c4d16",//"005e84081f9f408586de873338fa54b7"
// //   voiceIntegrationKey :"c041e4ba3ade40898e1eb9e8a16c4d16",
// //   enterpriseIntegrationKey:"0edbb40477fb4b1b95e45bb2af44d6bd",
// //   cyberPayApiUrl: "https://payment-api.staging.cyberpay.ng/api/v1/payments/",
 

// IntegrationKey : window['integrationKey'] || "e38f9fbc3b8d4b4d866f1735b6d670e2", 
//   voiceIntegrationKey : window['voiceIntegrationKey'] || "86d2f18326ea4783bbf5bee893fd0fcf",
//   enterpriseIntegrationKey:window['enterpriseIntegrationKey']||"1552fba96cc94cab93523d18bdb8c496",
//   cyberPayApiUrl: "https://payment-api.cyberpay.ng/api/v1/payments",
//   ProviderId : 4,
//   GenericErrorMsg : "An error occured",
//   CyberPayReturnURL: `${location.protocol}//${location.host}/completecyberpay`,
//   expiredAccId : 3,
//   pausedAccId:0,
//   UnsubscribeUrl:"https://externalconn.cyberspacelte.net.ng:9088/api/utilities/Unsubscribe",
//  webhookUrl : webHookUrl,
//  vat: 7.5
// };
